export const KM_PER_MILE = 1.609344;

export const EMAIL_PII_REGEX = /letsdothis\|.*-.*-.*-.*-.*/;
